exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .pc-content-header .page-head-with-button h2 {\n  margin: 0 0 15px 0;\n}\n\n.pc .pc-content-header .page-head-with-button button {\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .pc .pc-content-header .page-head-with-button {\n    display: flex;\n    align-items: center;\n  }\n\n  .pc .pc-content-header .page-head-with-button h2 {\n    flex: 1 1 auto;\n    margin-right: 16px;\n    margin-bottom: 0;\n  }\n\n  .pc .pc-content-header .page-head-with-button button {\n    flex: 0 0 auto;\n    width: auto;\n  }\n}\n\n.pc .pc-content-header .page-head-standalone h2 {\n  margin: 0;\n}\n\n", ""]);

// exports
